module.exports = __webpack_public_path__ + "static/OR4s-3bab64b8e9636c203f58be87d7069868.jpg";